import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  toasts: [],
  actionModal: {
    open: false,
    title: '',
    message: '',
    details: null,
    retryCallbackId: null,
  },
  connection: {
    isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
    showOfflineBanner: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  },
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    showToast: (state, action) => {
      const toast = {
        id: action.payload.id || uuidv4(),
        type: action.payload.type || 'error',
        title: action.payload.title || '',
        message: action.payload.message || '',
        actionLabel: action.payload.actionLabel || null,
        actionCallbackId: action.payload.actionCallbackId || null,
        duration: action.payload.duration ?? 5000,
        createdAt: Date.now(),
      };
      state.toasts.push(toast);
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
    showActionModal: (state, action) => {
      state.actionModal = {
        open: true,
        title: action.payload.title || 'Aktion fehlgeschlagen',
        message: action.payload.message || 'Bitte versuche es erneut.',
        details: action.payload.details || null,
        retryCallbackId: action.payload.retryCallbackId || null,
      };
    },
    hideActionModal: (state) => {
      state.actionModal = {
        open: false,
        title: '',
        message: '',
        details: null,
        retryCallbackId: null,
      };
    },
    setConnectionStatus: (state, action) => {
      state.connection.isOnline = action.payload.isOnline;
      state.connection.showOfflineBanner = !action.payload.isOnline;
    },
  },
});

export const {
  showToast,
  removeToast,
  showActionModal,
  hideActionModal,
  setConnectionStatus,
} = notificationSlice.actions;

export default notificationSlice.reducer;
